import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {visualFontSizes} from '../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface ParagraphProps {
  size?: VisualSizesEnum;
  className?: string;
}

/*
 * Style.
 */

interface ParagraphStyleProps {
  $size: VisualSizesEnum;
}

const StyledParagraphDiv = styled.div<ParagraphStyleProps>`
  font-size: ${(p) => visualFontSizes[p.$size]};
  line-height: 1.6;

  & + & {
    margin-top: 1em;
  }

  & > div:not(&) {
    line-height: 1.2;
  }
`;

/*
 * Component.
 */

export const Paragraph: FC<ParagraphProps> = (props) => (
  <StyledParagraphDiv $size={props.size || VisualSizesEnum.MEDIUM} className={props.className}>
    {props.children}
  </StyledParagraphDiv>
);
